import { useCallback, useEffect, useState } from "react";
import { posAPI } from "../../services/api";

/**
 * The till's cash drawer as the register knows it: whether the shop uses
 * one, whether it is open, and — only for someone who may manage cash —
 * what it should hold. Read again after anything that moves cash.
 *
 * Unknown (offline, or not read yet) never blocks the till: `known` stays
 * false and the register sells as before, the server having the last word.
 */
export const useDrawer = (staffKey) => {
  const [drawer, setDrawer] = useState({ known: false, enabled: false, open: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await posAPI.drawer();
      setDrawer({ known: true, ...data });
    } catch {
      // Keep what we knew; the next sale will say if the drawer is closed
    }
  }, []);

  useEffect(() => {
    if (staffKey) refresh();
  }, [staffKey, refresh]);

  return {
    ...drawer,
    // Blocks selling only when the server said so
    mustOpen: drawer.known && drawer.enabled && !drawer.open,
    refresh,
  };
};
